import {
  changeBookingFlowSelector,
  manageFlowBookingSelector,
} from '@/features/manage/manageSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

export const ChangeBookingFooterContent: FC = () => {
  const booking = useSelector(manageFlowBookingSelector);
  const changeFlow = useSelector(changeBookingFlowSelector);

  if (!booking?.id) return null;

  return (
    <div className="flex items-center gap-2">
      <Icons.location />
      <Typography variant="body1-bold">
        <TransText i18nKey={changeFlow ?? 'changeTrips'} />
      </Typography>
      {/* `code` is the human-readable booking number shown everywhere else
          (e.g. the "Booking: X" header); `id` is the internal GUID. */}
      {booking.code && (
        <Typography variant="body1">({booking.code})</Typography>
      )}
    </div>
  );
};
